export const CLIENTS_STATUSES = {
  ACTIVE: 'Active',
  EXPIRED: 'Expired',
};
